import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

import { Box } from 'components/library';
import Skeleton from 'components/Skeleton';

import { QRCodeProps } from './types';

import * as S from './styled';

const QRCodeComponent = ({ isLoading, deepLinkUrl }: QRCodeProps) => {
    return (
        <S.ScanQrCodeWrapper data-testid="deeplinkQRCode" data-locator="deeplinkQRCode">
            {isLoading ? (
                <Skeleton />
            ) : (
                <Box $paddingX={5} $paddingTop={5} $paddingBottom={5} $backgroundColor="on-primary" $borderRadius={12}>
                    <QRCodeSVG size={140} value={deepLinkUrl} />
                </Box>
            )}
        </S.ScanQrCodeWrapper>
    );
};

export default QRCodeComponent;
